/* eslint-disable react/display-name */
/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import Box from "@material-ui/core/Box";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import useStyles from "../../CockpitStyleJs/styleFilter";
import Tooltip from "@material-ui/core/Tooltip";
import C from "constants/cockpit.js";
import { useDispatch, useSelector } from "react-redux";
import i18n from "i18n";
import React from "react";
import lod_ from "lodash";

import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
/**
 *
 */
export default ({}) => {
	const dispatch = useDispatch();
	const { selectedConversation, isCold, convContactFilter } = useSelector(state => state.cockpit);
	const classes = useStyles();
	const hasFRU = !lod_.isEmpty(selectedConversation?.contact?.FRU);
	const isFilterActive = !lod_.isEmpty(convContactFilter);

	const handleSaveFilters = () => {
		dispatch({
			type: C.SET_CONV_CONTACT_FILTER,
			payload: lod_.isEmpty(convContactFilter) ? selectedConversation?.contact?.FRU || "" : ""
		});
	};

	return !isCold ? (
		<Tooltip title={i18n.t("COC.filterShowOnlyContactConv")} placement="top">
			<Box className={classes.filterButton} mt={1}>
				<ToggleButtonGroup exclusive size="small" disabled={!hasFRU && !isFilterActive}>
					<ToggleButton
						value={true}
						fontSize="small"
						disabled={!hasFRU && !isFilterActive}
						onClick={() => handleSaveFilters()}
						style={
							!hasFRU && !isFilterActive
								? { color: "#9e9e9e", background: "#f0f0f0" }
								: isFilterActive
									? { color: "black", background: "#0000001f" }
									: {}
						}
					>
						<PermContactCalendarIcon fontSize="small" />
					</ToggleButton>
				</ToggleButtonGroup>
			</Box>
		</Tooltip>
	) : (
		<></>
	);
};
